import React, { useState, useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Swal from "sweetalert2";
import CustomPagination from "../../common/custompagination";
import Sorting from "../../common/sorting";
import Loader from "../../common/loader";
import Breadcrums from "../../common/breadcrumbs";
import $ from "jquery";
import {
  SWAL_SETTINGS,
  THEME_COLORS,
  showFilterlistByUser,
} from "../../../../utils/Constants";
import {
  capitalizeFirstLetter,

  formateDateWithMonth,

  handleServerValidations,

  TrimText,
  writeMyExcel,
} from "../../../../utils/commonfunction";
import StatusFilter from "../../common/statusFilter";
import { List, Delete } from "../../services/appointmentrating.service"
import { Placeholder, Tooltip, Whisper } from "rsuite";
import { usePermission } from '../../../../utils/commonfunction';
import CustomRangepicker from "../../common/rangepicker";

const RatingList = () => {
  const { t } = useTranslation();
  const { can } = usePermission();
  const params = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const [list, setList] = useState([]);
  const [statsupdate, setStatusUpdate] = useState("false");
  const [datalength, setDataLength] = useState("");
  const [itemperpage] = useState(10);
  const [sorting, setSorting] = useState({});
  const [defaultSorting, setDefaultSorting] = useState(true);
  const [page, setPage] = useState(1);
  const [loader, setLoader] = useState(true);
  const [downloadReport, setDownloadReport] = useState(false);
  const [search, setSearch] = useState({});
  const [globalsearch, setGlobalSearch] = useState("");
  const breadcrumbs = [
    { title: t("sidebar_link_dashboard"), url: "/admin/dashboard" },
    { title: "Ratings", url: "" },
  ];
  const [resetdate, setResetDate] = useState(false);
  const [statusUpdated, setStatusUpdated] = useState(false)
  const [dateRange, setDateRange] = useState({});





  /********** MULTI SELECT <<<<<<********* */

  useEffect(() => {
    const getData = setTimeout(() => {
      if (search) {
        setLoader(true);
        const formData = new FormData();
        formData.append("page", params.pgno);
        formData.append("per_page", itemperpage);
        formData.append("sort", JSON.stringify(sorting));
        formData.append("search", JSON.stringify(search));
        formData.append("global_search", globalsearch);
        if (dateRange.start) formData.append("start_date", dateRange.start);
        if (dateRange.end) formData.append("end_date", dateRange.end);
        List(formData)
          .then((data) => {
            setDataLength(data.data.total_records);
            // setSerialNo(data.data.offset);
            setList(data && data.data && data.data.list ? data.data.list : []);
            //   console.log("data.data.data_ids", data.data.data_ids);

            setPage(data && data.data && data.data.page ? data.data.page : 1);
            setLoader(false);
          })
          .catch((error) => {
            console.log("error ====> ", error);
          });
      }
    }, 300);
    return () => clearTimeout(getData)
  }, [
    location,
    statsupdate,
    sorting,
    search,
    globalsearch,
    itemperpage,
    params.pgno,
    statusUpdated,
    dateRange
  ]);

  const viewFunction = (row) => {
    navigate(
      `/admin/ratings/view/${row._id}`
    );
  };

  // sorting function start
  const handleSort = (e, column) => {
    setDefaultSorting(false);
    let sort = { order: 0, column: column };
    if (e.target.classList.contains("assc")) {
      sort.order = -1;
    } else {
      sort.order = 1;
    }
    setSorting(sort);
  };
  // sorting end

  // search or filter function
  const prepareSearch = (key, value) => {
    let sr = { ...search };
    if (String(value).length > 0) {
      sr[key] = value;
    } else {
      delete sr[key];
    }
    setSearch(sr);
  };


  const resetFilter = (e) => {
    e.preventDefault();
    setGlobalSearch("");
    prepareSearch();
    setSearch({});
    setDateRange({});
    setResetDate(!resetdate);
    // $("#defaultstatus")[0].selectedIndex = 0;
  };








  const DeleteFunction = (row) => {

    Swal.fire({
      customClass: 'swal-wide',
      title: t("msg_are_you_sure"),
      text: t("you_not_be_able_to_revert_this"),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: THEME_COLORS.ADMIN_PRIMARY,
      cancelButtonColor: "#000",
      confirmButtonText: t("btn_yes_delete"),
      cancelButtonText: t("btn_cancel")
    }).then((result) => {
      if (result.isConfirmed) {
        let id = row._id;
        const formdata = new FormData();

        Delete({ _id: row._id }).then(response => {
          if (response.success) {
            Swal.fire({
              icon: 'success',
              text: response.message,
              ...SWAL_SETTINGS
            })
            setStatusUpdate(!statsupdate)

          } else {
            Swal.fire({
              icon: 'error',
              text: handleServerValidations(response),
              ...SWAL_SETTINGS
            })
          }
        }).catch((error) => {
          console.log("deleteError", error)
        });
      }
    })
  }

  const handleExportToExcel = () => {
    setDownloadReport(true);
    const formData = new FormData();
    formData.append("page", params.pgno);
    formData.append("per_page", datalength);
    formData.append("sort", JSON.stringify(sorting));
    formData.append("search", JSON.stringify(search));
    formData.append("global_search", globalsearch);
    List(formData)
      .then((data) => {
        setDownloadReport(false);
        const headers = [
          t('label_user_name'),
          t('label_user_email'),
          t('label_associate_name'),
          t('label_associate_email'),
          t('label_type'),
          t('label_rating'),
          t('label_rating_detail'),
        ];

        const rows = data.data.list.map((row) => [
          row?.userData?.name ? row.userData.name : "N/A",
          row?.userData?.email ? row.userData.email : "N/A",
          row?.associateData?.name ? row.associateData.name : "N/A",
          row?.associateData?.email ? row.associateData.email : "N/A",
          row?.type ? (row.type === "associate_to_babe" ? "By Associate" : "By Babe User") : "N/A",
          row?.rating ? row.rating : "N/A",
          row?.ratingDetails ? TrimText(row.ratingDetails, 30) : "N/A",
        ]);

        writeMyExcel([headers, ...rows], `${t('label_rating_report')}.xlsx`);
      })
      .catch((error) => {
        setDownloadReport(false);
        console.log("error ====> ", error);
      });

  };




  return (
    <>
      <Breadcrums data={breadcrumbs} />
      {/* table section */}
      <div className="animation_fade">
        <div className="card custom-card">
          <div className="card-body">
            <div className="d-flex justify-content-between align-items-center mb-4">
              <h6 className="main-content-label">
                Ratings
              </h6>
              <div className="d-flex align-items-center">
                <div className="form-group mb-0 me-3">
                  <div className="form-group mb-0 rangepicker_container filter_design">
                    <i className="fa fa-search calender_icon"></i>
                    <input
                      type="search"
                      className="form-control"
                      value={globalsearch}
                      placeholder={t("input_placeholder_search")}
                      onChange={(e) => {
                        setGlobalSearch(e.target.value);
                      }}
                    />
                  </div>
                </div>
                <div className="me-3">
                  <CustomRangepicker
                    GetDateRange={(e) => {
                      setDateRange(e && e.start ? e : {});
                    }}
                    resetdate={resetdate}
                  />
                </div>

                {/* <div className="me-3">
                  <StatusFilter
                    data={showFilterlistByUser}
                    prepareSearch={prepareSearch}
                  />
                </div> */}

                <button
                  type="reset"
                  value="Reset"
                  onClick={resetFilter}
                  className="btn ripple btn-main-primary signbtn ripple mr-2"
                >
                  {t("btn_reset_filter")}
                </button>

                <button
                  type=""
                  value=""
                  onClick={() => { handleExportToExcel() }}
                  className="btn ripple btn-main-primary signbtn"
                  disabled={downloadReport}
                >
                  {t("btn_export_report")}
                </button>

              </div>
            </div>
            {
              loader ?
                <Placeholder.Paragraph className="w-100 admin-placeholder" rowHeight={30} rowSpacing={5} active={true} rows={7} />
                :
                <>
                  <div className="table-responsive min-h-400">
                    <table className="table table-bordered card-table border-top text-nowrap w-100">
                      <thead>
                        <tr>
                          <th className="position-relative select_head">
                            <span>{t("list_heading_sno")}</span>
                          </th>


                          <th>
                            <div className="sorting_column">
                              <span>{t("label_user_name")}</span>

                            </div>
                          </th>

                          <th>{t("label_user_email")}</th>

                          <th>
                            <div className="sorting_column">
                              <span>{t("label_associate_name")}</span>

                            </div>
                          </th>

                          <th>{t("label_associate_email")}</th>
                          <th>
                            <div className="sorting_column">
                              <span>{t("label_type")}</span>

                            </div>
                          </th>

                          <th className="">{t("label_rating")}</th>
                          <th className="status_head">{t("label_rating_detail")}</th>

                          {(can("/admin/ratings/view") || can("/admin/ratings/delete")) && (
                            <th className="action_head">{t("list_heading_action")}</th>
                          )}
                        </tr>
                      </thead>
                      <tbody>

                        <>
                          {list.length ? (
                            list.map((row, i) => {
                              return (
                                <tr key={i}>
                                  <td>{row ? (page - 1) * itemperpage + i + 1 : null}</td>
                                  <td>{row?.userData?.name ? row?.userData?.name : "N/A"}</td>
                                  <td>{row?.userData?.email ? row?.userData?.email : "N/A"}</td>
                                  <td>{row?.associateData?.name ? row?.associateData?.name : "N/A"}</td>
                                  <td>{row?.associateData?.email ? row?.associateData?.email : "N/A"}</td>

                                  <td>{row?.type ? row?.type === "associate_to_babe" ? "By Associate" : "By Babe User" : "N/A"}</td>
                                  <td>{row?.rating ? row?.rating : "N/A"}</td>
                                  <td>{row?.ratingDetails ? TrimText(row?.ratingDetails, 30) : "N/A"}</td>



                                  {(can("/admin/ratings/view") || can("/admin/ratings/delete")) && (
                                    <td>
                                      <div className="btn-toolbar table-actions" role="toolbar" aria-label="Toolbar with button groups">
                                        <div className="btn-group btn-group-sm" role="group" aria-label="Second group">
                                          {can("/admin/ratings/view") && (
                                            <Whisper placement="top" controlId="control-id-hover" trigger="hover" speaker={<Tooltip style={{ fontWeight: 'bold' }}>View</Tooltip>}>
                                              <button type="button" className="btn view" onClick={() => { viewFunction(row) }}>
                                                <i className="ri-eye-fill"></i>
                                              </button>
                                            </Whisper>
                                          )}

                                          {can("/admin/ratings/delete") && (
                                            <Whisper placement="top" controlId="control-id-hover" trigger="hover" speaker={<Tooltip style={{ fontWeight: 'bold' }}>Delete</Tooltip>}>
                                              <button type="button" className="btn delete" onClick={() => { DeleteFunction(row) }}>
                                                <i className="ri-delete-bin-6-fill"></i>
                                              </button>
                                            </Whisper>
                                          )}

                                        </div>
                                      </div>
                                    </td>
                                  )}
                                </tr>
                              );
                            })
                          ) : (
                            <tr>
                              <td colSpan={14} className="text-center">
                                {t("msg_no_records")}
                              </td>
                            </tr>
                          )}
                        </>

                      </tbody>
                    </table>
                  </div>
                  <div
                    className=""
                    id="example1_info"
                    role="status"
                    aria-live="polite"
                  >
                    <b>
                      {t("msg_total_records")} : {datalength ? datalength : "0"}
                    </b>
                  </div>
                  {datalength && datalength > 0 ? (
                    <CustomPagination
                      datalength={datalength}
                      itemperpage={itemperpage}
                      currentPage={page}
                      setPage={setPage}
                      pageRoute={[
                        {
                          name: "Reataurant",
                          path: "/admin/ratings/list",
                        },
                      ]}
                    />
                  ) : (
                    ""
                  )}
                </>}
          </div>
        </div>
      </div>

    </>
  );
};

export default RatingList;
